import { render, staticRenderFns } from "./EventReportsPage.vue?vue&type=template&id=cc121454&"
import script from "./EventReportsPage.vue?vue&type=script&lang=js&"
export * from "./EventReportsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports